export const normalize = images => {
  return images
    .filter(image => !!image.url)
    .map(image => {
      // Translating raw images to source/thumbnail objects for backwards compatibility
      return image.source ? image : { source: image.url, thumbnail: image.url };
    });
};
